import * as THREE from "three";
import type { Vec3 } from "@genjiball/protocol";

const TRAIL_LEN = 30;

export class BallTrail {
  readonly object: THREE.Line;
  private positions: Float32Array;
  private geom: THREE.BufferGeometry;
  private head: number = 0;

  constructor() {
    this.positions = new Float32Array(TRAIL_LEN * 3);
    this.geom = new THREE.BufferGeometry();
    this.geom.setAttribute("position", new THREE.BufferAttribute(this.positions, 3));
    const mat = new THREE.LineBasicMaterial({ color: 0xfff5b1, transparent: true, opacity: 0.6 });
    this.object = new THREE.Line(this.geom, mat);
    this.object.frustumCulled = false;
  }

  reset(at: Vec3) {
    for (let i = 0; i < TRAIL_LEN; i++) {
      this.positions[i * 3] = at[0];
      this.positions[i * 3 + 1] = at[1];
      this.positions[i * 3 + 2] = at[2];
    }
    this.head = 0;
    this.geom.attributes.position!.needsUpdate = true;
  }

  push(p: Vec3) {
    this.head = (this.head + 1) % TRAIL_LEN;
    this.positions[this.head * 3] = p[0];
    this.positions[this.head * 3 + 1] = p[1];
    this.positions[this.head * 3 + 2] = p[2];
    this.geom.attributes.position!.needsUpdate = true;
  }

  dispose() {
    this.geom.dispose();
    (this.object.material as THREE.Material).dispose();
  }
}
